import { Lang } from "./App/app";
import { macs365ClientId, macsDIAClientId, schwarzwaldClientId } from "./client-ids";
import { DashboardInfoId } from "./pages/DashboardInfo/Dashboardinfo";
import { macs365Uri } from "./uris";

export type ClientType = 'web' | 'mobile_app';

export interface Client {
  name: string,
  extendedName: string,
  clientId: string,
  origin: string,
  type: ClientType,

  // Important for dashboard when we get list of relevant apps
  // Value must be the same as what we get from the backend
  relevantAppIdentifier: string,

  // Special cases for clients which we need to show message instead of a redirect
  dashboardInfo?: {
    click?: DashboardInfoId | null,
  },

  // we define it as a function which returns a string
  // because we want to get the latest value of lang

  // use this uri only as a fallback
  // e.g. no clientId and/or redirectUri is defined
  fallbackUri: ( lang: Lang, userAgent: string, origin?: string ) => string,

  // This flag is ment to redirect client directly to application without
  // showing a list of relevant apps
  showDashBoardWhenOnlyOption: boolean,
  rank: number
}

export const macs365Client: Client = {
  name: 'm365',
  extendedName: 'macs365',
  relevantAppIdentifier: 'macs365',
  clientId: macs365ClientId,
  origin: macs365Uri,
  type: 'web',
  fallbackUri: ( lang, userAgent, origin = macs365Uri ) => `${ origin }/${ lang }/login`,
  showDashBoardWhenOnlyOption: false,
  rank: 1
};

const s20Origin = 'https://www.hella-gutmann.com/de/for-workshops/diagnoseloesungen/fahrzeugdiagnose/mega-macs-s-20';
export const s20Client: Client = {
  name: 'S 20',
  extendedName: 'mega macs S 20',
  relevantAppIdentifier: 's20',
  dashboardInfo: {
    click: 's20-please-start-device',
  },
  clientId: schwarzwaldClientId,
  origin: s20Origin,
  type: 'mobile_app',
  fallbackUri: ( lang, userAgent, origin = s20Origin ) => {
    return /Android/i.test(userAgent)
      ? `https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=de.hellagutmann.megamacss20&&hl=${lang}`
      : "/dashboard/info/s20-please-start-device"
  },
  showDashBoardWhenOnlyOption: true,
  rank: 2
};

const x20Origin = 'https://hella-gutmann.com';
export const x20Client: Client = {
  name: 'X 20',
  extendedName: 'CSC Tool X 20',
  relevantAppIdentifier: 'x20',
  dashboardInfo: {
    click: 'x20-please-sign-in',
  },
  clientId: 'missing_client_id',
  origin: x20Origin,
  type: 'mobile_app',
  fallbackUri: ( lang, userAgent, origin = x20Origin) => `/dashboard/info/x20-please-sign-in`,
  showDashBoardWhenOnlyOption: true,
  rank: 3
};

// const macsDIAOrigin = 'https://macsdia.com';
// export const macsDIA: Client = {
//   name: 'macsDIA',
//   extendedName: 'macsDIA',
//   clientId: macsDIAClientId,
//   origin: macsDIAOrigin,
//   fallbackUri: ( lang, origin = macsDIAOrigin ) => `${ origin }?lang=${ lang }`,
// };

export const supportedClients: Client[] = [
  x20Client,
  s20Client,
  macs365Client,
];
